import { defaultVertexShader } from '.'

const rainbowFragmentShader = `
    precision mediump float;
        
    varying vec2 v_texcoord;

    uniform float u_intensity;
    uniform float u_progress;
    uniform sampler2D u_texture;

    vec3 hueShift(vec3 color, float hue) {
        const vec3 k = vec3(0.57735, 0.57735, 0.57735);
        float cosAngle = cos(hue);
        return vec3(color * cosAngle + cross(k, color) * sin(hue) + k * dot(k, color) * (1.0 - cosAngle));
    }

    void main() {
        float intensity = 0.2 + (u_intensity * 0.8);
        vec4 color = texture2D(u_texture, v_texcoord);
        vec3 greyScale = vec3(.5, .5, .5);
        vec4 gray = vec4(vec3(dot(color.rgb, greyScale)), color.a);
        vec4 red = vec4(1., 0., 0., color.a) * gray;
        vec4 mixed = mix(red, color, 1. - intensity);
        vec3 shifted = hueShift(mixed.rgb, radians(u_progress * 360.0));
        gl_FragColor =  vec4(shifted, color.a);
    }
`

export const rainbowShaderSource = {
    fragment: rainbowFragmentShader,
    vertex: defaultVertexShader,
}
